import { Suspense, type ReactNode, memo } from 'react';
import { CContainer } from '@coreui/react';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse" />
  </div>
);

interface IContentProps {
  content: ReactNode;
}

const Content = ({ content }: IContentProps) => {
  return (
    <main className="main">
      <CContainer fluid>
        <Suspense fallback={loading}>{content}</Suspense>
      </CContainer>
    </main>
  );
};

export default memo(Content);
